// extracted by mini-css-extract-plugin
export default {"liveBox":"redblink_liveBox__AM4Z5","dot":"redblink_dot__2L+FE","blink":"redblink_blink__s9nMu","text":"redblink_text__NITgb"};